import thunk from 'redux-thunk'
import { applyMiddleware, compose, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'

import * as AppReducer from './reducer'

export const middlewareProd = compose(applyMiddleware(thunk))
export const middlewareDev = composeWithDevTools(applyMiddleware(reduxImmutableStateInvariant(), thunk))

const middleware = process.env.NODE_ENV === 'production' ? middlewareProd : middlewareDev

const initStore = () => createStore(AppReducer.rootReducer, AppReducer.initialState, middleware)

export default initStore
